export default "__VITE_ASSET__c6ce215f__"